var map = {
	"./1/a.png": 73129,
	"./2/a.png": 60422,
	"./3/a.png": 20695,
	"./A-Importancia-da-documentacao-de-um-projeto-de-software/A-Importancia-da-documentacao-de-um-projeto-de-software.jpg": 25545,
	"./A-Importancia-de-acompanhar-um-projeto-de-forma-rigorosa/A-Importancia-de-acompanhar-um-projeto-de-forma-rigorosa.jpg": 86031,
	"./A-importancia-da-usabilidade-do-software/A-importancia-da-usabilidade-do-software.png": 87513,
	"./Boas-praticas-de-programacao/Boas-praticas-de-programacao.png": 99759,
	"./Ciclo-de-vida-de-um-projeto-de-desenvolvimento-aplicacional/Ciclo-de-vida-de-um projeto-de-desenvolvimento-aplicacional.jpeg": 29207,
	"./Ciclo-de-vida-de-um-projeto-de-desenvolvimento-aplicacional/Ciclo-de-vida-de-um projeto-de-desenvolvimento-aplicacional.png": 80798,
	"./Como-realizar-testes-de-utilizadores/como-realizar-testes-de-utilizadores.png": 67075,
	"./Importancia-de-um-Software-de-Gestao-de-Trabalho/Importância de um Software de Gestão de Trabalho.png": 93191,
	"./Laravel-Vuejs-Vantagens/laravel-vuejs-vantagens.jpg": 61337,
	"./Sistema-de-logs/importancia_logs.jpeg": 56183,
	"./Testes-de-utilizadores/Testes-de-utilizadores.png": 49751,
	"./Vamos-falar-de-futebol/fotoXPTO.jpg": 50737
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 54555;